module.exports = __webpack_public_path__ + "media/images/comment_ic-y-b7287008ee1a994decbdf0767be3c13c.svg";